"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SYSTEM_CURRENCIES = exports.ALL_CURRENCIES = exports.REGULAR_CURRENCIES = exports.REWARD_CURRENCY = exports.PLATFORM_FEE_CURRENCY = exports.MAIN_CURRENCY = void 0;
const enums_1 = require("../enums");
exports.MAIN_CURRENCY = enums_1.SystemCurrency.USDT;
exports.PLATFORM_FEE_CURRENCY = enums_1.SystemCurrency.OKLP;
exports.REWARD_CURRENCY = enums_1.SystemCurrency.USDT_REWARD;
/**
 * @deprecated Use `SUPPORTED_CURRENCIES` instead.
 */
exports.REGULAR_CURRENCIES = [exports.MAIN_CURRENCY, exports.PLATFORM_FEE_CURRENCY];
exports.ALL_CURRENCIES = [exports.MAIN_CURRENCY, exports.PLATFORM_FEE_CURRENCY, exports.REWARD_CURRENCY];
/**
 * @deprecated Use `REGULAR_CURRENCIES` instead.
 */
exports.SYSTEM_CURRENCIES = exports.REGULAR_CURRENCIES;
//# sourceMappingURL=system-currencies.js.map